module.exports = __webpack_public_path__ + "tm.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/tm.svg
// module id = 1100
// module chunks = 0